import styled from "styled-components";
import theme from "../../styles/theme";
import Button from ".././Button";
import FlexBox, { FlexGrow } from "../FlexBox";
import { ClickableIcon } from "../Icon";
import Modal from "../Modal";
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { Icon } from "@mui/material";
import { VersionContext } from "../../context/VersionContext";
import LoadingSpinner from "../LoadingSpinner";

interface State {
  searchTerm: string;
}

type PrerequisiteModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  confirmFunction: () => void;
  title: string;
  setIsSnackbarOpen: any;
  setIsErrorOpen: any;
  setMessage: any;
  setErrorMessage: any;
  loading: boolean;
  setLoading: any;
};
const Title = styled.div`
  gap: 10px;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
const Flex = styled(FlexGrow)`
  padding: 18px;
  // width: 350px;
  background: #0066ff1a;
  border-radius: 4px;
  margin: 24px 0px;
  color: ${theme.color.darkBlueGray300};
`;
const Pillars = styled("div")`
  overflow-y: scroll;
  min-height: 350px;
  max-height: 45px;
  margin-top: 10px;
  padding: 5px;
  border-radius: 5px;
  font-size: 5px;
`;
const Item = styled("div")`
  padding: 5px;
  cursor: pointer;
  font-size: 14px;
  text-overflow: ellipsis;
  max-width: "100%";
  white-space: nowrap;
  overflow: hidden;
`;
const UploadStyle = styled("label")`
  min-height: 414px;
  display: flex;
  width: 100%;
  // background: #0013ff;
  color: #0013ff;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  border: 2px dashed #cad9ff;
  cursor: pointer;
`;
const UploadReplace = styled("label")`
  display: flex;
  width: 100%;
  // background: #0013ff;
  color: #0013ff;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
  border: 2px dashed #cad9ff;
  cursor: pointer;
`;
const ImportModal = ({
  title,
  isOpen,
  setOpen,
  setIsSnackbarOpen,
  setIsErrorOpen,
  setMessage,
  setErrorMessage,
  confirmFunction,
  loading,
  setLoading,
}: PrerequisiteModalProps): JSX.Element => {
  const [prefixes, setPrefixes] = useState([]);
  const [file, setFile] = useState<any>(null);
  // const [onSelect, setOnSelect] = useState
  const [selectedPrefixes, setSelectedPrefixes] = useState<any>([]);
  const fileInputRef = useRef(null);
  const { version } = useContext(VersionContext);
  const [uploadDetail, setUploadDetail] = useState<any>(null);

  // useEffect(() => {
  //   getPillarPrefix();
  // }, []);

  const getPillarPrefix = (fileUploaded: any) => {
    const formdata = new FormData();
    formdata.append("zipfile", fileUploaded);
    
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    
    axios
      .post("/version/importpillar?zipfile", formdata, config)
      .then((res) => {
        const tempArr: any = [];
        res.data.pillars?.forEach((pillar: any) =>
          tempArr.push({
            value: pillar.pillar_prefix,
            label: pillar.title,
            id: pillar.pillar_prefix,
          })
        );
        setPrefixes(tempArr);
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.data?.error) {
          setIsErrorOpen(true);
          setErrorMessage(err.response.data.error);
        }
        setFile(null);
        setPrefixes([]);
      });
  };

  const handleFileChange = (event: any) => {
    const fileUploaded = event.target.files[0];
    setFile(fileUploaded);
    getPillarPrefix(fileUploaded);
  };
  const onSelect = (prefix: any) => {
    const index = selectedPrefixes?.findIndex(
      (p: any) => p.pillar_prefix === prefix.pillar_prefix
    );
    let updatedPrefixes = selectedPrefixes && [...selectedPrefixes]; // Create a new array reference
    if (index < 0) {
      updatedPrefixes?.push(prefix);
    } else {
      updatedPrefixes = updatedPrefixes?.filter(
        (_: any, i: any) => i !== index
      );
    }
    setSelectedPrefixes(updatedPrefixes); // Update state using set function
  };

  const handleImport = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("zipfile", file);
    formData.append(
      "curriculum_version",
      JSON.stringify(version.version_number)
    );
    selectedPrefixes.forEach((obj: any, index: number) => {
      for (let key in obj) {
        formData.append(`data[${index}][${key}]`, obj[key]);
      }
    });
    formData.append("pillars", JSON.stringify(selectedPrefixes));
    
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    
    axios
      .post(`/version/import?curriculum_version=${version.version_number}`, formData, config)
      .then((res: any) => {
        setLoading(false);
        // setOpen(false);
        // setSelectedPrefixes([]);
        // setFile(null);
        setUploadDetail(res.data);
      })
      .catch((err) => {
        console.log('err', err.response)
        setLoading(false);
        if (err.response?.data?.error) {
          setIsErrorOpen(true);
          setErrorMessage(err.response.data.error);
        }
        else{
          setIsErrorOpen(true);
          setErrorMessage('Something went wrong!');
          setFile(null)
        }
      });
  };
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: { zIndex: "999999" },
          content: { minWidth: "750px", padding: "0 16px 24px 16px" },
        }}
      >
        <FlexBox style={{ paddingTop: 15 }}>
          <FlexGrow>
            <Title>
              {/* <Icon color="warning">warning_rounded</Icon> */}
              {title}
            </Title>
          </FlexGrow>
          {/* <ClickableIcon
            name="close"
            // color="white"
            onClick={() => setOpen(false)}
          /> */}
        </FlexBox>
        <FlexBox>
          {file ? (
            <Flex>
              {!uploadDetail ? (
                <UploadReplace htmlFor="fileInput">
                  <span style={{ padding: 10 }}>{file?.name}</span>

                  <Icon style={{ padding: 10, color: "#0013ff" }}>
                    drive_folder_upload_icon
                  </Icon>
                </UploadReplace>
              ) : (
                <>
                  <span style={{ fontWeight: "bold" }}>Imported File : </span>
                  <span style={{ color: "#0013ff" }}>{file?.name}</span>
                </>
              )}
              {!uploadDetail && (
                <input
                  id="fileInput"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  type="file"
                  accept=".zip"
                  onChange={handleFileChange}
                />
              )}
              <div style={{ fontWeight: "bold", paddingTop: 10 }}>
                {uploadDetail ? "Summary" : "Select Pillars"}
              </div>
              <Pillars
                className="visible-scrollbar"
                style={{ background: "#ffffff" }}
              >
                {uploadDetail ? (
                  <div style={{ marginTop: 10 }}>
                    {uploadDetail?.map((detail: any, k: number) => (
                      <div
                        key={k}
                        style={{
                          paddingBottom: 10,
                          display: "flex",
                          alignItems: "start",
                          gap: 5,
                        }}
                      >
                        <Icon
                          style={{
                            color: detail.includes("successfully")
                              ? "#009200"
                              : "#ff7c7c",
                          }}
                        >
                          {detail.includes("successfully")
                            ? "check_circle_icon"
                            : "cancel"}
                        </Icon>
                        {detail}
                      </div>
                    ))}
                  </div>
                ) : loading ? (
                  <LoadingSpinner />
                ) : (
                  prefixes?.map((prefix: any, k: number) => (
                    <label
                      key={k}
                      htmlFor={prefix.id}
                      style={{ cursor: "pointer" }}
                    >
                      <Item
                        onClick={() => {}}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                          background: "" === prefix.id ? "#0061ff" : "",
                          color: "" === prefix.id ? "#ffffff" : "",
                        }}
                        className="hover"
                        title={prefix.title}
                      >
                        <input
                          id={prefix.id}
                          type="checkbox"
                          checked={selectedPrefixes?.find(
                            (v: any) => v === prefix.id
                          )}
                          onClick={() =>
                            onSelect({
                              pillar_prefix: prefix.id,
                              title: prefix.label,
                            })
                          }
                        />
                        <span style={{ minWidth: 40 }}>{prefix.id}</span>
                        {" : "}
                        {prefix.label}
                      </Item>
                    </label>
                  ))
                )}
              </Pillars>
            </Flex>
          ) : (
            <Flex>
              <UploadStyle htmlFor="fileInput">
                <div style={{ padding: 100 }}>
                  <Icon sx={{ fontSize: "100px", opacity: 0.2 }}>
                    drive_folder_upload_icon
                  </Icon>
                  <div style={{}}>Upload Zip File</div>
                </div>
              </UploadStyle>
              <input
                id="fileInput"
                ref={fileInputRef}
                style={{ display: "none" }}
                type="file"
                accept=".zip"
                onChange={handleFileChange}
              />
            </Flex>
          )}
        </FlexBox>
        {!uploadDetail ? (
          <FlexBox justify="end">
            <Button
              className={"reduce_opct_onhover"}
              style={{
                width: "151px",
              }}
              isOutline
              type="button"
              onClick={() => {
                setOpen(false);
                setSelectedPrefixes([]);
                setFile(null);
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={selectedPrefixes.length === 0 || !file}
              className={
                selectedPrefixes.length === 0 || !file
                  ? ""
                  : "reduce_opct_onhover"
              }
              style={{
                boxShadow: "0 2px 2px #00000033",
                width: "151px",
                // fontSize: 12,
                color: "#ffffff",
                background: theme.color.blueButton,
                border: "none",
              }}
              type="button"
              onClick={() => {
                handleImport();
                // setOpen(false);
              }}
            >
              Import
            </Button>
          </FlexBox>
        ) : (
          <FlexBox justify="end">
            <Button
              className={"reduce_opct_onhover"}
              style={{
                boxShadow: "0 2px 2px #00000033",
                width: "151px",
                // fontSize: 12,
                color: "#ffffff",
                background: theme.color.blueButton,
                border: "none",
              }}
              isOutline
              type="button"
              onClick={() => {
                setOpen(false);
                setSelectedPrefixes([]);
                setFile(null);
                setUploadDetail(null);
              }}
            >
              Dismiss
            </Button>
          </FlexBox>
        )}
      </Modal>
    </>
  );
};

export default ImportModal;
